import { createContext } from "react";

const promptDataContext = createContext();

export default promptDataContext ;